import moment from 'moment';
import { Expansion, ExpansionLevelCap, TExpansionInfo } from '../../../shared/gameConfig/expansion';
import {
  RealmConnectionType as SharedRealmConnectionType,
  WoWDifficultyId
} from '../../../shared/gameConfig/sharedTypes';
import { gameConfig } from './gameConfig';

export const MIN_EXPANSION_ITEM_LEVEL = 233;

export const NAME_CHANGE_COOLDOWN_DAYS = 30;

export const SHOW_PATRON_LABEL_ABOVE_LEVEL = 2;

export const FAR_FUTURE_DATE = moment.utc('2030-01-01T00:00:00Z');

export const DEFAULT_KEYSTONE_LEADERBOARD_PAGE_SIZE = 100;
export const DEFAULT_RAID_LEADERBOARD_PAGE_SIZE = 100;

//
// Dragonflight Dates
//
export const DF_LAUNCH_DATE = moment.utc('2022-11-28T23:00:00Z');

// FIXME: this probably isn't necessary
export const enum TeamNamespace {
  MYTHICPLUS = 'mythic-plus'
}

export type TRoleResource = {
  slug: 'tank' | 'healer' | 'dps';
  name: string;
};

export const ROLE_LIST: TRoleResource[] = [
  {
    slug: 'tank',
    name: 'Tank'
  },
  {
    slug: 'healer',
    name: 'Healer'
  },
  {
    slug: 'dps',
    name: 'DPS'
  }
];

export const ROLE_SLUGS: string[] = ['tank', 'healer', 'dps'];

export const enum ROLE_IDS {
  NONE = 0,
  TANK = 1,
  HEALER = 2,
  DPS = 3,
  DPS_MELEE = 4,
  DPS_RANGED = 5
}

export const ROLE_ID_TO_STRING: any = {
  [ROLE_IDS.TANK]: 'tank',
  [ROLE_IDS.HEALER]: 'healer',
  [ROLE_IDS.DPS]: 'dps',
  [ROLE_IDS.DPS_MELEE]: 'dps-melee',
  [ROLE_IDS.DPS_RANGED]: 'dps-ranged'
};

export const ROLE_STRING_TO_ID: any = {
  tank: ROLE_IDS.TANK,
  healer: ROLE_IDS.HEALER,
  dps: ROLE_IDS.DPS,
  'dps-melee': ROLE_IDS.DPS_MELEE,
  'dps-ranged': ROLE_IDS.DPS_RANGED
};

export const SEASONS = gameConfig.MythicPlusSeasons;
export const SEASONS_SORTED = gameConfig.MythicPlusSeasonsSorted;
export const SEASONS_BY_SLUG = gameConfig.MythicPlusSeasonsBySlug;
export const SEASONS_BY_PARTITION_EVENT_ID = gameConfig.MythicPlusSeasonsByPartitionEventId;
/**
 * @deprecated Should use SEASONS_BY_SLUG instead
 */
export const SEASONS_BY_EXACT_SLUGS = gameConfig.MythicPlusSeasonsByExactSlug;

export const getSeasonBySlug = gameConfig.getSeasonBySlug;
export const getEventTitleFromSeasonSlug = gameConfig.getEventTitleFromSeasonSlug;
export const mythicScoreUseAlternateDungeon = gameConfig.mythicScoreUseAlternateDungeon;

export const RAID_DIFFICULTY_LIST = gameConfig.RaidDifficulties;
export const DIFFICULTY_SLUGS = RAID_DIFFICULTY_LIST.map((d) => d.slug);
export const DIFFICULTY_SLUGS_DESCENDING = [...DIFFICULTY_SLUGS].reverse();

export const RealmConnectionType = SharedRealmConnectionType;

export const LevelCap = {
  ...ExpansionLevelCap,

  Current: gameConfig.CurrentLevelCap,
  Previous: gameConfig.PreviousLevelCap
};

export const COVENANTS = [
  {
    name: 'Kyrian',
    id: 1
  },
  {
    name: 'Necrolord',
    id: 4
  },
  {
    name: 'Night Fae',
    id: 3
  },
  {
    name: 'Venthyr',
    id: 2
  }
];

export const EXPANSIONS_INFO = gameConfig.Expansions;

export const EXPANSIONS_INFO_BY_EXPANSION_ID = new Map<number, TExpansionInfo>(
  EXPANSIONS_INFO.map((xpacInfo: TExpansionInfo) => [xpacInfo.expansionId, xpacInfo])
);

export const EXPANSIONS_INFO_BY_EXPANSION_SLUG = new Map<string, TExpansionInfo>(
  EXPANSIONS_INFO.map((xpacInfo: TExpansionInfo) => [xpacInfo.slug, xpacInfo])
);

export const MAX_SOULBIND_TRAITS = 6;
export const MAX_SOULBIND_CONDUITS = 6;

// FIXME: make this get sent up from the server
export const FACTIONS = [
  {
    name: 'Alliance',
    slug: 'alliance'
  },
  {
    name: 'Horde',
    slug: 'horde'
  }
];

export const FACTIONS_WITH_MIXED = [
  {
    name: 'Alliance',
    slug: 'alliance'
  },
  {
    name: 'Horde',
    slug: 'horde'
  },
  {
    name: 'Mixed Factions',
    slug: 'mixed'
  }
];

export const DifficultyId = WoWDifficultyId;

export const DIFFICULTIES = gameConfig.RaidDifficulties;

export const enum EventGroupCharterLimits {
  Default = 5,
  Admin = 999
}

export type TRaidKillCountsByDifficulty = {
  normal: number;
  heroic: number;
  mythic: number;
  [key: string]: number;
};

export const RAID_METADATA = gameConfig.Raids;
export const RAID_METADATA_BY_SLUG = gameConfig.RaidsBySlug;

export const DUNGEON_SCORE_MAIN_FACTOR = 1.5;
export const DUNGEON_SCORE_ALT_FACTOR = 0.5;

export const enum KeystoneBrackets {
  Bracket_2_to_10 = 100,
  Bracket_11_to_15 = 101,
  Bracket_16_to_20 = 102,
  Bracket_21_to_25 = 103,
  Bracket_26_plus = 104
}

export const MPLUS_TEAM_FEATURED_BRACKETS = [
  KeystoneBrackets.Bracket_16_to_20,
  KeystoneBrackets.Bracket_11_to_15,
  KeystoneBrackets.Bracket_2_to_10
];

export const ALL_KEYSTONE_BRACKETS = [
  {
    id: KeystoneBrackets.Bracket_2_to_10,
    name: 'common:mythic-plus-brackets.bronze.title',
    short_name: 'Bronze Bracket',
    icon: 'achievement_challengemode_bronze',
    slug: 'bronze'
  },
  {
    id: KeystoneBrackets.Bracket_11_to_15,
    name: 'common:mythic-plus-brackets.silver.title',
    short_name: 'Silver Bracket',
    icon: 'achievement_challengemode_silver',
    slug: 'silver'
  },
  {
    id: KeystoneBrackets.Bracket_16_to_20,
    name: 'common:mythic-plus-brackets.gold.title',
    short_name: 'Gold Bracket',
    icon: 'achievement_challengemode_gold',
    slug: 'gold'
  },
  {
    id: KeystoneBrackets.Bracket_21_to_25,
    name: 'common:mythic-plus-brackets.platinum.title',
    short_name: 'Platinum Bracket',
    icon: 'achievement_challengemode_platinum',
    slug: 'platinum'
  },
  {
    id: KeystoneBrackets.Bracket_26_plus,
    name: 'common:mythic-plus-brackets.diamond.title',
    short_name: 'Diamond Bracket',
    icon: 'ui_rankedpvp_05_small',
    slug: 'diamond'
  }
];

export const KEYSTONE_BRACKETS_BY_ID: { [key: string]: any } = ALL_KEYSTONE_BRACKETS.reduce((accum: any, item: any) => {
  accum[item.id] = item;
  return accum;
}, {});

export function getKeystoneBracketForLevel(level: number) {
  if (level >= 26) {
    return KeystoneBrackets.Bracket_26_plus;
  } else if (level >= 21) {
    return KeystoneBrackets.Bracket_21_to_25;
  } else if (level >= 16) {
    return KeystoneBrackets.Bracket_16_to_20;
  } else if (level >= 11) {
    return KeystoneBrackets.Bracket_11_to_15;
  }
  return KeystoneBrackets.Bracket_2_to_10;
}

export function getExpansionLevelCap(expansion: Expansion): number | undefined {
  switch (expansion) {
    case Expansion.ClassicEra:
      return ExpansionLevelCap.Classic;
    case Expansion.TheBurningCrusade:
      return ExpansionLevelCap.BurningCrusade;
    case Expansion.WrathOfTheLichKing:
      return ExpansionLevelCap.WrathOfTheLichKing;
    case Expansion.Cataclysm:
      return ExpansionLevelCap.Cataclysm;
    case Expansion.BattleForAzeroth:
      return ExpansionLevelCap.BattleForAzerothPostSquish;
    case Expansion.Legion:
      return ExpansionLevelCap.Legion;
    case Expansion.Shadowlands:
      return ExpansionLevelCap.Shadowlands;
    case Expansion.Dragonflight:
      return ExpansionLevelCap.Dragonflight;
    case Expansion.TheWarWithin:
      return ExpansionLevelCap.TheWarWithin;
    case Expansion.Midnight:
      return ExpansionLevelCap.Midnight;
    default:
      return undefined;
  }
}

// list of all the widgets that support version updates from backend.
export const enum WidgetNames {
  BossProgress = 'boss-progress',
  RaidLeaderboard = 'raid-leaderboard',
  HealthOverAttempt = 'health-over-attempt',
  GuildGearCompare = 'guild-gear-compare',
  Versus = 'versus',
  GuildGearComposition = 'guild-gear-composition',
  TeamDungeons = 'team-dungeons'
}

export type TPatronPremium = 'premium_5' | 'premium_4' | 'premium_3' | 'premium_2' | 'premium_1';

export type TPremiumList = {
  premium_5_count: number;
  premium_4_count: number;
  premium_3_count: number;
  premium_2_count: number;
  premium_1_count: number;
  [key: string]: number;
};

export const enum ArticleParticipantCategory {
  CO_AUTHOR = 'co_author',
  SPOTLIGHT = 'spotlight'
}

export const enum UserStarredReplaysLimit {
  DEFAULT = 5,
  PATRON_REVERED = 10,
  PATRON_EXALTED = 20,
  PATRON_ILLUSTRIOUS = 30
}

export const enum RecentRunsListLimit {
  DEFAULT = 5,
  REVERED = 10,
  EXALTED = 15,
  ILLUSTRIOUS = 20
}

export function getRecentRunsLimitForPatronLevel(patronLevel?: number | null): number {
  if (patronLevel === 5) {
    return RecentRunsListLimit.ILLUSTRIOUS;
  }
  if (patronLevel === 4) {
    return RecentRunsListLimit.EXALTED;
  }
  if (patronLevel === 3) {
    return RecentRunsListLimit.REVERED;
  }
  return RecentRunsListLimit.DEFAULT;
}

export const enum GuildActivityType {
  MemberFirstSeen = 'member_first_seen',
  MemberJoined = 'member_joined',
  MemberLeft = 'member_left'
}

export const enum UserReplayAttemptStatus {
  VALID = 'valid',
  INVALID = 'invalid',
  PENDING = 'pending',
  DEFAULT = PENDING
}

export const enum GroupCharterHistoryStatus {
  JOINED = 'joined', // character joined the team
  KICKED = 'kicked', // character was kicked from the team by captain
  LEFT = 'left' // character left the team of own accord
}

export enum EventTeamMemberHistoryStatus {
  JOINED = 'joined', // member joined the team
  KICKED = 'kicked', // member was kicked from the team by captain
  LEFT = 'left' // member left the team of own accord
}
